import { render } from "./BookingPoisList.vue?vue&type=template&id=3d59c78f&scoped=true"
import script from "./BookingPoisList.vue?vue&type=script&lang=js"
export * from "./BookingPoisList.vue?vue&type=script&lang=js"

import "./BookingPoisList.vue?vue&type=style&index=0&id=3d59c78f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d59c78f"]])

export default __exports__